module.exports = __webpack_public_path__ + "img/41.49d10140.png";